import { makeGraphQLRequest } from '../../utils/requestUtils';

export async function getConversations(id, folderName = null) {
  const query = `query conversations(
    $id: ID
    $folderName: String
  ) {
    conversations(id: $id, folderName: $folderName)  {  conversations{ id sender subject newMessage date participants, attachmentsFlag received, cage} 
  }
    }`;

  const variables = { id, folderName };
  const response = makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function getFolderData(id) {
  const query = `query messageFolders($id: ID){ 
    messageFolders (id: $id)   {  starred, folderNames }}`;

  const variables = { id };
  const response = makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function addFolder(id, folderName) {
  const query = `mutation addFolder($id: ID, $folderName: String) { addFolder (id: $id, folderName: $folderName) { folderNames response{ message status} } }`;

  const variables = { id, folderName };
  const response = makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function deleteFolder(id, folderName) {
  const query = `mutation deleteFolder($id: ID, $folderName: String) { deleteFolder (id: $id, folderName: $folderName) { folderNames response{ message status} } }`;

  const variables = { id, folderName };
  const response = makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function moveFolders(id, convoArray, folderName) {
  const query = `mutation moveFolders($id: ID, $convoArray: [String]  $folderName: String) { moveFolders (id: $id, convoArray: $convoArray folderName: $folderName) {  response{ message status} } }`;
  const variables = { id, convoArray, folderName };
  const response = makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function getDraft(id, convoId) {
  const query = `query getDraft($id: ID, $convoId: String){getDraft(id: $id, convoId: $convoId)  { entry, attachments, title, recepients}}`;

  const variables = { id, convoId };
  const response = makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function putDraft(
  id,
  convoId,
  entry,
  attachments = [],
  title = null,
  recepients = null,
) {
  const query = `mutation putDraft($id: ID, $convoId: String, $entry: String $attachments: [String] $title: String, $recepients: [String] ) { putDraft (id: $id, convoId: $convoId, entry: $entry attachments: $attachments, title: $title, recepients: $recepients) { convoId  }}`;

  const variables = { id, convoId, entry, attachments, title, recepients };
  const response = makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function deleteDraft(id, convoArray) {
  const query = `mutation deleteDrafts($id: ID, $convoArray: [String], ) { deleteDrafts (id: $id, convoArray: $convoArray, ) { response{message status}  }}`;

  const variables = { id, convoArray };
  const response = makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function getMessageContents(id, convoId) {
  const query = `query messageContents($id: ID, $convoId: String){messageContents(id: $id, convoId: $convoId)  { convoEntriesHeader{subject cage companyName convoEntriesList{entry, attachments, sender, name, entryId, created  }} }}`;

  const variables = { id, convoId };
  const response = makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function addMessageToConversation(
  id,
  convoIdList,
  entry,
  attachmentNames,
) {
  const query = `mutation addMessage($id: ID, $convoIdList: [String], $entry: String, $recepients: [String], $attachmentNames: [String]) { addMessage (id: $id, convoIdList: $convoIdList, entry: $entry, recepients: $recepients, attachmentNames: $attachmentNames) { convoEntriesHeader{subject cage companyName convoEntriesList{entry, attachments, sender, name, entryId, created  }}   }}`;
  console.log("addMessage graphQL")
  const variables = { id, convoIdList, entry, recepients: [], attachmentNames };
  const response = makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function addConversation(
  id,
  title,
  entry,
  recepients,
  attachmentNames,
) {
  const query = `mutation addConversation($id: ID, $title: String, $entry: String, $recepients: [String], $attachmentNames: [String]) { addConversation (id: $id, title: $title, entry: $entry, recepients: $recepients, attachmentNames: $attachmentNames) { conversations{ id sender subject newMessage date participants,  received cage}  }}`;
  console.log("addConversation graphQL")
  const variables = { id, title, entry, recepients, attachmentNames };
  const response = makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function searchConversations(id, searchText) {
  const query = `query search(
    $id: ID
    $searchText: String
  ) {
    search(id: $id, searchText: $searchText)  {  conversations{ id sender subject newMessage date participants,  received cage} 
  }
    }`;

  const variables = { id, searchText };
  const response = makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function markAsRead(id, convoArray) {
  const query =
    'mutation markConversationsAsRead($id: ID, $convoArray: [String]) { markConversationsAsRead (id: $id, convoArray: $convoArray ) {  response{ message status} } }';
  const variables = { id, convoArray };
  const response = makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}
export async function getMessageCount(id) {
  const query = `query msgCount(
    $id: ID
  ) {
    msgCount(id: $id) {

      newMsgCount
      }
    }`;

  // Variables
  const variables = { id };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response.msgCount;
}



// WEBPACK FOOTER //
// ./src/pages/messageCenter/graphql.js